import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useApiData, fmtDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Icon } from "@/components/common/Icon";
import { FullLoader } from "@/components/common/ProtectedRoute";
import { PageTitle, StatCard } from "@/components/shell/DashboardShell";
import { RequestTable } from "@/components/portal/RequestTable";
import { REQUEST_TYPES } from "@/data/portal";

export default function PortalDashboard() {
  const { user } = useAuth();
  const { data, loading } = useApiData("/requests");
  if (loading) return <FullLoader />;
  const list = data || [];
  const open = list.filter((r) => ["submitted", "under_review", "in_progress"].includes(r.status)).length;
  return (
    <div data-testid="portal-dashboard">
      <PageTitle eyebrow="Vendor portal" title={`Welcome, ${user.contact_name.split(" ")[0]}`} text="Raise a request below. Our team updates status as it progresses." />
      <div className="grid gap-4 sm:grid-cols-3">
        <StatCard label="Open requests" value={open} icon="Activity" tone="amber" testid="portal-stat-open" />
        <StatCard label="Completed" value={list.filter((r) => r.status === "completed").length} icon="CheckCircle2" testid="portal-stat-completed" />
        <StatCard label="Total raised" value={list.length} icon="Layers" testid="portal-stat-total" />
      </div>
      <h2 className="mt-12 text-lg font-semibold text-slate-900">Raise a new request</h2>
      <div className="mt-4 grid gap-4 sm:grid-cols-2 xl:grid-cols-5">
        {Object.entries(REQUEST_TYPES).map(([key, t]) => (
          <Link key={key} to={`/portal/new/${key}`} className="card-base group flex flex-col p-6 hover:border-[#C20500]/40" data-testid={`portal-new-${key}`}>
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#FBEDEA] transition-colors group-hover:bg-[#C20500]"><Icon name={t.icon} className="h-5 w-5 text-[#C20500] group-hover:text-white" /></span>
            <p className="mt-4 font-semibold text-slate-900">{t.label}</p>
            <p className="mt-1 flex-1 text-xs leading-relaxed text-slate-500">{t.blurb}</p>
            <ArrowRight className="mt-4 h-4 w-4 text-slate-400 transition-transform group-hover:translate-x-1 group-hover:text-[#C20500]" />
          </Link>
        ))}
      </div>
      <div className="mt-12 flex items-center justify-between">
        <h2 className="text-lg font-semibold text-slate-900">Recent requests</h2>
        <Link to="/portal/requests" className="text-sm font-semibold text-[#C20500]" data-testid="portal-view-all-requests">View all</Link>
      </div>
      <div className="mt-4"><RequestTable rows={list.slice(0, 5)} basePath="/portal/requests" /></div>
      <p className="mt-6 text-xs text-slate-400">Member since {fmtDate(user.created_at)}</p>
    </div>
  );
}
